export default __webpack_public_path__ + "static/cbg-isolate-mobile-542ec890133701f27f718c0541eb7fd5.png";